// src/chat.ts
function parseChartBlock(content) {
  try {
    const parsed = JSON.parse(content.trim());
    if (parsed && typeof parsed === "object" && "type" in parsed && "title" in parsed && "data" in parsed && Array.isArray(parsed.data)) {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

// src/workflow.ts
var WORKFLOW_TRIGGER_TYPES = [
  "manual-test",
  "scheduled",
  "employee-created",
  "employee-updated",
  "payroll-generated",
  "payroll-finalized"
];
var WORKFLOW_EVENT_TRIGGER_TYPES = [
  "employee-created",
  "employee-updated",
  "payroll-generated",
  "payroll-finalized"
];
function isWorkflowEventTriggerType(value) {
  return WORKFLOW_EVENT_TRIGGER_TYPES.includes(value);
}

// src/dashboard.ts
var DASHBOARD_FORMATTER_IDS = {
  number: "number",
  percent: "percent",
  currency_mur: "currency_mur",
  compact: "compact"
};
var DASHBOARD_CHART_COLOR_SCHEMES = {
  default: "default",
  pastel: "pastel",
  vivid: "vivid",
  mono: "mono",
  cool: "cool",
  warm: "warm"
};
var DASHBOARD_SIZE_PRESETS = {
  // Size controls width; height is auto-measured from content on the client.
  // Stored h is a fallback until measurement runs.
  sm: { w: 3, h: 8 },
  md: { w: 6, h: 8 },
  lg: { w: 8, h: 8 },
  full: { w: 12, h: 8 }
};
function gridToSize(w) {
  if (w >= 12) return "full";
  if (w >= 8) return "lg";
  if (w >= 6) return "md";
  return "sm";
}
function humanizeLabel(raw) {
  if (!raw) return raw;
  const spaced = raw.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2").replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  if (!spaced) return raw;
  return spaced.split(" ").map((word) => {
    if (/^[A-Z0-9]{2,}$/.test(word)) return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(" ");
}
export {
  DASHBOARD_CHART_COLOR_SCHEMES,
  DASHBOARD_FORMATTER_IDS,
  DASHBOARD_SIZE_PRESETS,
  WORKFLOW_EVENT_TRIGGER_TYPES,
  WORKFLOW_TRIGGER_TYPES,
  gridToSize,
  humanizeLabel,
  isWorkflowEventTriggerType,
  parseChartBlock
};
//# sourceMappingURL=index.mjs.map